"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var react_cropper_1 = __importDefault(require("react-cropper"));
require("cropperjs/dist/cropper.css");
var Button_1 = __importDefault(require("@common/button/Button"));
var utils_1 = require("./utils");
var mediasSlice_1 = require("../../state/mediasSlice");
function EditImageModal(props) {
    var _a, _b;
    var imageCroppingAllowed = props.imageCroppingAllowed, imageRotationAllowed = props.imageRotationAllowed, closeModal = props.closeModal, handleImageTransformations = props.handleImageTransformations, adId = props.adId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var imagesMetadata = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.imagesMetadataSelector)(state, adId); });
    var selectedMediaId = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaIdSelector)(state, adId); });
    var selectedImageMetadata = imagesMetadata.find(function (image) { return image.id === selectedMediaId; });
    var selectedImage = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedImageSelector)(state, adId); });
    var filename = selectedImageMetadata.src.split('/').pop();
    var transformations = selectedImageMetadata === null || selectedImageMetadata === void 0 ? void 0 : selectedImageMetadata.transformations;
    var cropperStyle = (0, utils_1.getCropperStyle)(selectedImageMetadata.originalSize);
    var cropperRef = (0, react_1.useRef)(null);
    var _c = __read((0, react_1.useState)((transformations === null || transformations === void 0 ? void 0 : transformations.cropping) || { x1: 0, y1: 0, x2: 0, y2: 0 }), 2), cropping = _c[0], setCropping = _c[1];
    var _d = __read((0, react_1.useState)((transformations === null || transformations === void 0 ? void 0 : transformations.rotation) || 0), 2), rotation = _d[0], setRotation = _d[1];
    var cancelChanges = function () { return closeModal(); };
    var saveChanges = function () {
        if (handleImageTransformations) {
            var refinedCropping = (0, utils_1.refineCroppingAreaToImage)(cropping, rotation, selectedImageMetadata === null || selectedImageMetadata === void 0 ? void 0 : selectedImageMetadata.originalSize);
            var transformations_1 = {
                rotation: rotation,
                cropping: (0, utils_1.isCropped)(refinedCropping) ? refinedCropping : null,
            };
            handleImageTransformations(selectedMediaId, transformations_1);
        }
        closeModal();
    };
    var rotate = function (angle) {
        var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
        var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
        if (cropper) {
            var _a = getCroppingData(cropper), x = _a.x, y = _a.y, width = _a.width, height = _a.height, rotate_1 = _a.rotate;
            var rotatedData = (0, utils_1.getDataAfterRotation)(angle, { x: x, y: y, width: width, height: height, rotate: rotate_1 }, selectedImageMetadata.originalSize);
            var rotationAngle = rotation + angle;
            cropper.setData(rotatedData);
            Math.abs(rotationAngle) === 360 ? setRotation(0) : setRotation(rotationAngle);
        }
    };
    var revertToOriginal = function () {
        var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
        var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
        if (cropper) {
            cropper.rotateTo(0);
            cropper.clear();
            setRotation(0);
            setCropping({ x1: 0, y1: 0, x2: 0, y2: 0 });
        }
    };
    var getCroppingData = function (cropper) {
        var cropperData = cropper.getData();
        return Object.fromEntries(Object.entries(cropperData).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return [key, Math.round(value)];
        }));
    };
    var onCropButtonClick = function () {
        var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
        var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
        if (cropper) {
            if ((0, utils_1.isCropped)(cropping)) {
                cropper.clear();
                setCropping({ x1: 0, y1: 0, x2: 0, y2: 0 });
            }
            else {
                cropper.crop();
                var _a = getCroppingData(cropper), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                setCropping({ x1: x, y1: y, x2: width + x, y2: height + y });
            }
        }
    };
    var handleCrop = function () {
        var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
        var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
        if (cropper) {
            var _a = getCroppingData(cropper), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            setCropping({ x1: x, y1: y, x2: width + x, y2: height + y });
        }
    };
    var onReady = function () {
        var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
        var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
        cropping &&
            (cropper === null || cropper === void 0 ? void 0 : cropper.setData({
                x: cropping.x1,
                y: cropping.y1,
                width: cropping.x2 - cropping.x1,
                height: cropping.y2 - cropping.y1,
            }));
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('popstate', closeModal);
        return function () { return window.removeEventListener('popstate', closeModal); };
    }, []);
    return (react_1.default.createElement("div", { className: "edit-image-container" },
        react_1.default.createElement("div", { className: "edit-image-main" },
            (selectedImage === null || selectedImage === void 0 ? void 0 : selectedImage.objectURL) && (react_1.default.createElement(react_cropper_1.default, { src: selectedImage.objectURL, className: "cropper-js-container", crop: handleCrop, ref: cropperRef, style: cropperStyle, viewMode: 2, autoCrop: !!(0, utils_1.isCropped)(cropping), rotateTo: rotation, ready: onReady, minCropBoxWidth: 32, minCropBoxHeight: 32 })),
            react_1.default.createElement("div", { className: "image-info" },
                react_1.default.createElement("p", { className: "field-name" }, t('ITEM.EDIT_IMAGE_MODAL.ORIGINAL_IMAGE')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("span", { className: "image-info-label" },
                        " ",
                        t('ITEM.EDIT_IMAGE_MODAL.WIDTH'),
                        " "),
                    react_1.default.createElement("span", null, (_a = selectedImageMetadata === null || selectedImageMetadata === void 0 ? void 0 : selectedImageMetadata.originalSize) === null || _a === void 0 ? void 0 :
                        _a.width,
                        "px")),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("span", { className: "image-info-label" }, t('ITEM.EDIT_IMAGE_MODAL.HEIGHT')),
                    react_1.default.createElement("span", null, (_b = selectedImageMetadata === null || selectedImageMetadata === void 0 ? void 0 : selectedImageMetadata.originalSize) === null || _b === void 0 ? void 0 :
                        _b.height,
                        "px")),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("span", { className: "image-info-label" }, t('ITEM.EDIT_IMAGE_MODAL.FILE_NAME')),
                    react_1.default.createElement("span", { className: "eva-file-name-value" }, filename)),
                react_1.default.createElement("p", { className: "field-name" },
                    t('ITEM.EDIT_IMAGE_MODAL.MODIFIED_IMAGE'),
                    " "),
                imageCroppingAllowed && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, "X1"),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? react_1.default.createElement("span", null, cropping === null || cropping === void 0 ? void 0 :
                            cropping.x1,
                            "px") : react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014"))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, "Y1"),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? react_1.default.createElement("span", null, cropping === null || cropping === void 0 ? void 0 :
                            cropping.y1,
                            "px") : react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014"))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, "X2"),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? react_1.default.createElement("span", null, cropping === null || cropping === void 0 ? void 0 :
                            cropping.x2,
                            "px") : react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014"))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, "Y2"),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? react_1.default.createElement("span", null, cropping === null || cropping === void 0 ? void 0 :
                            cropping.y2,
                            "px") : react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014"))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, t('ITEM.EDIT_IMAGE_MODAL.CROP_WIDTH')),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? (react_1.default.createElement("span", null,
                            ((cropping === null || cropping === void 0 ? void 0 : cropping.x2) || 0) - ((cropping === null || cropping === void 0 ? void 0 : cropping.x1) || 0),
                            "px")) : (react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014")))),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement("span", { className: "image-info-label" }, t('ITEM.EDIT_IMAGE_MODAL.CROP_HEIGHT')),
                        react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? (react_1.default.createElement("span", null,
                            ((cropping === null || cropping === void 0 ? void 0 : cropping.y2) || 0) - ((cropping === null || cropping === void 0 ? void 0 : cropping.y1) || 0),
                            "px")) : (react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014")))))),
                imageRotationAllowed && (react_1.default.createElement("p", null,
                    react_1.default.createElement("span", { className: "image-info-label" }, t('ITEM.EDIT_IMAGE_MODAL.ROTATION')),
                    react_1.default.createElement("span", null, !rotation ? react_1.default.createElement("span", { className: "image-cropper-dash" }, "\u2014") : react_1.default.createElement("span", null,
                        rotation,
                        "\u00B0")))),
                react_1.default.createElement(Button_1.default, { onClick: revertToOriginal, text: t('ITEM.EDIT_IMAGE_MODAL.REVERT_BUTTON'), type: "primary" }))),
        react_1.default.createElement("div", { className: "edit-image-control" },
            imageCroppingAllowed && (react_1.default.createElement("div", { onClick: onCropButtonClick, className: "edit-image-control-button" },
                react_1.default.createElement("i", { className: "implioicons-crop" }),
                react_1.default.createElement("span", null, (0, utils_1.isCropped)(cropping) ? t('ITEM.EDIT_IMAGE_MODAL.CLEAR_CROP') : t('ITEM.EDIT_IMAGE_MODAL.CROP')))),
            imageRotationAllowed && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { onClick: function () { return rotate(90); }, className: "edit-image-control-button" },
                    react_1.default.createElement("i", { className: "implioicons-rotate-clockwise" }),
                    react_1.default.createElement("span", null, t('ITEM.EDIT_IMAGE_MODAL.ROTATE_NINETY'))),
                react_1.default.createElement("div", { onClick: function () { return rotate(-90); }, className: "edit-image-control-button" },
                    react_1.default.createElement("i", { className: "implioicons-rotate-counter-clockwise" }),
                    react_1.default.createElement("span", null, t('ITEM.EDIT_IMAGE_MODAL.ROTATE_MINUS_NINETY'))))),
            react_1.default.createElement("div", { className: "edit-image-modal-buttons" },
                react_1.default.createElement(Button_1.default, { onClick: cancelChanges, text: t('ITEM.EDIT_IMAGE_MODAL.CANCEL_BUTTON'), type: "secondary" }),
                react_1.default.createElement(Button_1.default, { onClick: saveChanges, text: t('ITEM.EDIT_IMAGE_MODAL.SAVE_BUTTON'), type: "primary" })))));
}
exports.default = EditImageModal;
